var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "setSecurity"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v($t("8nxkxya", "全局启用MFA认证："))]), _c('RadioGroup', {
    on: {
      "on-change": _vm.enableMFA
    },
    model: {
      value: _vm.securityModel,
      callback: function ($$v) {
        _vm.securityModel = $$v;
      },
      expression: "securityModel"
    }
  }, _vm._l(_vm.model, function (item, index) {
    return _c('Radio', {
      key: index,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('div', {
    staticClass: "content"
  }, [_vm.securityModel == 2 ? [_c('div', {
    staticClass: "setSecurity"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v($t("q7di125", "用户范围："))]), _c('RadioGroup', {
    on: {
      "on-change": _vm.enableMFAScope
    },
    model: {
      value: _vm.effectiveScope,
      callback: function ($$v) {
        _vm.effectiveScope = $$v;
      },
      expression: "effectiveScope"
    }
  }, _vm._l(_vm.userList, function (item, index) {
    return _c('Radio', {
      key: index,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1)] : _vm._e()], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };